module.exports = __webpack_public_path__ + "img/thumbnail_Siamang_m_normal.ca41435b.png";